

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const login_tableApi = createAsyncThunk("login_table", async () => {
  const response = await axiosInstance.get("/login_table");
  return response.data;
});

const login_tableSlice = createSlice({
  name: "login_table",
  initialState: {
    login_table: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login_tableApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(login_tableApi.fulfilled, (state, action) => {
        state.login_table = action.payload;
        state.loading = false;
      })
      .addCase(login_tableApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default login_tableSlice.reducer;
